import Swal from 'sweetalert2'
import * as TXT from './Texts'

export const ERROR_ALERT = (msg:string)  => {

  Swal.fire({
      title: `${TXT.ATTENTION}`,
      text: `${msg}`,
      icon: 'error',
      confirmButtonText: `${TXT.OK}`
    })

}

export const SUCCESS_ALERT = (msg:string)  => {

  Swal.fire({
      title: `${TXT.ATTENTION}`,
      text: `${msg}`,
      icon: 'success',
      confirmButtonText: `${TXT.OK}`
    })

}

export const SUCCESS_INFO = (msg:string)  => {

  Swal.fire({
      title: `${TXT.ATTENTION}`,
      text: `${msg}`,
      icon: 'info',
      confirmButtonText: `${TXT.OK}`
    })

}

